import  React from 'react';

interface IProps {
    identifiedBy: string;
    radioButtons: {label: string, checked: boolean}[];
    onChanged: Function;
    title?: string;
  }
  
  interface IPropsState {
    radioButtonData: {label: string, checked: boolean}[];
  }

export class RadioButtonGroup extends React.Component<IProps, IPropsState> {

	constructor(props: IProps) {
		super(props);
		this.state = {radioButtonData: this.props.radioButtons};
	}

  LabelClicked = ((e: React.MouseEvent<HTMLLabelElement>): void =>{
	const target = e.target as HTMLLabelElement;
  	this.RadioButtonIdxSelected(parseInt(target.htmlFor));
  });

  SelectedButtonChanged = ((e: React.ChangeEvent<HTMLInputElement>): void =>{
  	this.RadioButtonIdxSelected(parseInt(e.target.value));
  });

    RadioButtonIdxSelected = ((selectedIdx: number) =>{
    	this.props.onChanged(selectedIdx);
    	const radioButtons: {label: string, checked: boolean}[] = [];

    	this.state.radioButtonData.forEach((radioButton, idx) => {
   			radioButtons.push({label: radioButton.label, checked: idx === selectedIdx});
    	});

    	this.setState(() => {
			 	return {radioButtonData: radioButtons};
    	});
    })

    render() {
    	return (
    		<div>
    			{this.props.title ? this.props.title : ''}
    			<ul className='radio-buttons'>
    				{ this.state.radioButtonData.map((radioButton, idx) => {
    					return <div key={idx.toString()}> 
    						<input
    							key={idx.toString()}
    							type='radio'
    							name={this.props.identifiedBy}
    							value={idx.toString()}
    							checked={radioButton.checked}
								onChange={this.SelectedButtonChanged}
    						/>
    						{' '}
    						<label htmlFor={idx.toString()} onClick={(e) => this.LabelClicked(e)}>{radioButton.label}</label><br/>
    					</div>;
    				})
    				}
    			</ul>
    		</div>
    	);
    }        
}
 